import React, { FC, PropsWithChildren, useContext } from 'react';
import { useMember } from './SessionProvider';
import { useIdentityService } from './IdentityProvider';
import { getUrl } from '../utils/url';

type EventType = 'INIT' | 'TOP_SEND' | 'SETTING_LINE_USE_BUTTON';

type RecordType<Type extends EventType, Data> = {
  name: Type;
  customDimention?: Data;
};
type InitRecordType = RecordType<
  'INIT',
  {
    enableLineButton: boolean;
    enableLineButtonTime: number;
    useStartTime: number;
    useStatus: true;
  }
>;
type TopRecordType = RecordType<
  'TOP_SEND',
  {
    loginTime: number;
    useStartTime: number;
    enableLineButton: boolean;
  }
>;
type SettingLineUseType = RecordType<
  'SETTING_LINE_USE_BUTTON',
  { enableLineButton: boolean; enableLineButtonTime: number }
>;
type RecordTypes = InitRecordType | TopRecordType | SettingLineUseType;

const KinesisContext = React.createContext<
  { record: (input: RecordTypes) => void } | undefined
>(undefined);

export const KinesisProvider: FC<PropsWithChildren> = ({ children }) => {
  const { member } = useMember();
  const { identityClient, useCompany } = useIdentityService();
  const { data: company } = useCompany(true);

  const record = (input: RecordTypes) => {
    fetch(getUrl('/api/kinesis'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        eventName: input.name,
        appType: 1,
        data: {
          kaiinNo: member.kaiinId,
          kaiLinkNo: member.companyId,
          accountId: member.id,
          accountType: identityClient.isAdmin ? 'sso' : 'normal',
          registerTime: member.createdAt,
          shogo: member.companyName,
          useStatus: company?.accountStatus,
          device: navigator.userAgent,
          ...(input.customDimention || {})
        }
      })
    });
  };
  const value = { record };
  return (
    <KinesisContext.Provider value={value}>{children}</KinesisContext.Provider>
  );
};

export const useKinesis = () => useContext(KinesisContext)!;
